import { render, staticRenderFns } from "./AccountsSalesAfpsDue.vue?vue&type=template&id=755ad24e&"
import script from "./AccountsSalesAfpsDue.vue?vue&type=script&lang=js&"
export * from "./AccountsSalesAfpsDue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports